var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { hasValue } from '../modules/utils/ValidationUtils';
import { NacionalidadeEnum } from '../model/enums/NacionalidadeEnum';
var CommonUtils = /** @class */ (function () {
    function CommonUtils() {
    }
    CommonUtils.cpfRequerente = function (requerimento) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (!requerimento) {
            return '';
        }
        if ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePf) === null || _a === void 0 ? void 0 : _a.cpf) {
            return (_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePf) === null || _b === void 0 ? void 0 : _b.cpf;
        }
        if ((_d = (_c = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _c === void 0 ? void 0 : _c.representante) === null || _d === void 0 ? void 0 : _d.cpf) {
            return (_f = (_e = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _e === void 0 ? void 0 : _e.representante) === null || _f === void 0 ? void 0 : _f.cpf;
        }
        if ((_h = (_g = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerimentoInventariante) === null || _g === void 0 ? void 0 : _g.pessoaFalecida) === null || _h === void 0 ? void 0 : _h.cpf) {
            return (_k = (_j = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerimentoInventariante) === null || _j === void 0 ? void 0 : _j.pessoaFalecida) === null || _k === void 0 ? void 0 : _k.cpf;
        }
        return '';
    };
    CommonUtils.cnpjRequerente = function (requerimento) {
        var _a, _b;
        if (!requerimento) {
            return '';
        }
        if ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _a === void 0 ? void 0 : _a.cnpj) {
            return (_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _b === void 0 ? void 0 : _b.cnpj;
        }
        return '';
    };
    CommonUtils.tipoRequerente = function (requerimento) {
        var _a;
        if (!requerimento)
            return undefined;
        if ((_a = requerimento.requerentePj) === null || _a === void 0 ? void 0 : _a.cnpj)
            return 'PJ';
        return 'PF';
    };
    CommonUtils.cpfRepresentanteLegal = function (requerimento) {
        var _a, _b;
        return ((_b = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _a === void 0 ? void 0 : _a.representante) === null || _b === void 0 ? void 0 : _b.cpf) || '';
    };
    CommonUtils.stripHtml = function (html) {
        var _a, _b;
        var div = document.createElement('div');
        div.innerHTML = html;
        return (_b = (_a = div.textContent) !== null && _a !== void 0 ? _a : div.innerText) !== null && _b !== void 0 ? _b : '';
    };
    return CommonUtils;
}());
export { CommonUtils };
export var nonNull = function (value) {
    return value !== null && value !== undefined;
};
export var isNull = function (value) {
    return value === null || value === undefined;
};
export var isEmpty = function (value) {
    return "".concat(value !== null && value !== void 0 ? value : '').length === 0;
};
export var TIME_SHOW_FIELD_ERROR = 5000;
export var NAO_SEI_INFO_MUNI_DESC_LBL = 'Não sei informar o município descrito no documento';
export var NAO_SEI_INFO_MUNI_DESC = {
    id: null,
    denominacao: NAO_SEI_INFO_MUNI_DESC_LBL,
    nome: NAO_SEI_INFO_MUNI_DESC_LBL,
};
export var NAO_SEI_INFO_MUNI_AT_LBL = 'Não sei informar o Município Atual';
export var NAO_SEI_INFO_MUNI_AT = {
    id: undefined,
    denominacao: NAO_SEI_INFO_MUNI_AT_LBL,
    nome: NAO_SEI_INFO_MUNI_AT_LBL,
    codigo: 1,
};
export var OUTRO_OPT_LBL = 'Outro';
export var OUTRO_OPT = {
    id: undefined,
    denominacao: OUTRO_OPT_LBL,
    nome: OUTRO_OPT_LBL,
};
export var NAO_SEI_INFO_OPT_LBL = 'Quero informar uma opção que não está na lista';
export var NAO_SEI_INFO_OPT = {
    id: undefined,
    denominacao: NAO_SEI_INFO_OPT_LBL,
    nome: NAO_SEI_INFO_OPT_LBL,
};
export var NAO_SEI = 'NAO_SEI';
export var normalizeText = function (text) { return (text || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim(); };
export var validatePfFields = function (pf) {
    var _a, _b;
    var informarNomeSocial = (_a = pf === null || pf === void 0 ? void 0 : pf.informarNomeSocial) !== null && _a !== void 0 ? _a : false;
    var isBrasileiro = (pf === null || pf === void 0 ? void 0 : pf.nacionalidade) === NacionalidadeEnum.BRASILEIRO;
    return [
        { key: 'cpfError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.cpf) },
        { key: 'nomeError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.nome) },
        { key: 'nomeSocialError', condition: informarNomeSocial && !hasValue(pf === null || pf === void 0 ? void 0 : pf.nomeSocial) },
        { key: 'dataNascimentoError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.dataNascimento) },
        { key: 'estadoCivilError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.estadoCivil) },
        { key: 'profissaoError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.profissao) },
        { key: 'nacionalidadeError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.nacionalidade) },
        { key: 'naturalidadeError', condition: isBrasileiro && !hasValue((_b = pf === null || pf === void 0 ? void 0 : pf.naturalidade) === null || _b === void 0 ? void 0 : _b.id) },
        { key: 'cepError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.cep) },
        { key: 'municipioError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.municipio) },
        { key: 'enderecoError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.endereco) },
        { key: 'celularError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.celular) },
        { key: 'estadoError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.estado) },
        { key: 'numeroError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.numero) },
        { key: 'bairroError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.bairro) },
        { key: 'emailError', condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.email) },
    ];
};
export var validateRtFields = function (rt) {
    var pf = rt === null || rt === void 0 ? void 0 : rt.pessoaFisica;
    return __spreadArray(__spreadArray([], validatePfFields(pf), true), [
        { key: 'ufConselhoClasseError', condition: !hasValue(rt === null || rt === void 0 ? void 0 : rt.ufConselhoClasse) },
        { key: 'numeroRegistroError', condition: !hasValue(rt === null || rt === void 0 ? void 0 : rt.numeroRegistro) },
        { key: 'conselhoClasseError', condition: !hasValue(rt === null || rt === void 0 ? void 0 : rt.conselhoClasse) },
        { key: 'codigoIncraError', condition: !hasValue(rt === null || rt === void 0 ? void 0 : rt.codigoIncra) },
    ], false);
};
export var SIM_OPT = { value: 'true', label: 'Sim' };
export var NAO_OPT = { value: 'false', label: 'Não' };
export var SIM_NAO_OPTS = [
    SIM_OPT,
    NAO_OPT,
];
export var NAO_SEI_NUM_FOL_LBL = 'Não sei o número da folha';
export var NAO_SEI_NUM_FOL = { denominacaoFolha: NAO_SEI_NUM_FOL_LBL };
export var NAO_SEI_NUM_LIV_LBL = 'Não sei o número do livro';
export var NAO_SEI_NUM_LIV = { denominacao: NAO_SEI_NUM_LIV_LBL };
